import React from "react";
import styles from "./style.module.css";
import { Box, Divider, TextField, Typography, Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import uploadIcon from "../../../../../../../../../../assets/images/upload-icons/upload-01.svg";
import editIcon from "../../../../../../../../../../assets/images/edit-icons/edit-03.svg";
import deleteIcon from "../../../../../../../../../../assets/images/trash-icons/trash-01.svg";
import { useTheme } from "../../../../../../../../../../context/themeContext";
import { useDispatch, useSelector } from "react-redux";
import {
  setIsDeleteProjectImageOpen,
  setIsModalProjectOpen,
  setOriginalProjectImage,
  setSelectedProjectImage,
} from "../../../../../../../../../../store/slices/profile/projectCoverImageSlice";

const DialogBox = ({ projectCoverImage }) => {
  const { theme } = useTheme();
  const dispatch = useDispatch();
  const { isModalProjectOpen, selectedProjectImage, originalProjectImage } =
    useSelector((state) => state.projectCoverImage);

  const closeModal = () => {
    dispatch(setIsModalProjectOpen(false));
    dispatch(setSelectedProjectImage(null));
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      const imageUrl = URL.createObjectURL(selectedFile);
      dispatch(setSelectedProjectImage(imageUrl));
      dispatch(setOriginalProjectImage(imageUrl));
    }

    dispatch(setIsModalProjectOpen(false));
  };

  const handleEdit = () => {
    dispatch(setSelectedProjectImage(originalProjectImage));
    dispatch(setIsModalProjectOpen(false));
  };

  const handleDelete = () => {
    dispatch(setIsDeleteProjectImageOpen(true));
    dispatch(setIsModalProjectOpen(false));
    dispatch(setSelectedProjectImage(null));
  };

  const style = {
    bgcolor: theme.palette.lightgrey.lightgrey500,
  };

  return (
    <Box
      className={styles.coverImage}
      sx={{
        display: isModalProjectOpen ? "flex" : "none",
        backgroundImage: `url(${selectedProjectImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <Modal
        open={isModalProjectOpen}
        onClose={closeModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              bgcolor: theme.palette.lightgrey.lightgrey500,
              width: {
                xs: "100%",
                md: "400px",
              },
            }}
            className={styles.dialogBox}
          >
            <Box sx={style} className={styles.container}>
              <Box sx={style} className={styles.text}>
                <Box sx={style} className={styles.subText}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: theme.palette.darkgrey.darkgrey800,
                      fontSize: "18px",
                      fontWeight: "500",
                    }}
                  >
                    Upload skill cover photo
                  </Typography>
                  <Typography
                    variant="body1"
                    sx={{ color: theme.palette.darkgrey.darkgrey500 }}
                  >
                    JPG, GIF, or PNG. Max size of 2MB
                  </Typography>
                </Box>
                <Close
                  onClick={closeModal}
                  sx={{
                    cursor: "pointer",
                    color: theme.palette.darkgrey.darkgrey300,
                  }}
                />
              </Box>
            </Box>
            <Divider />
            <Box sx={style} className={styles.upload}>
              <Box sx={style} className={styles.uploadPhoto}>
                <input
                  type="file"
                  accept="image/*"
                  id="imageInput"
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
                <TextField
                  fullWidth
                  value={"Choose photo from gallery"}
                  onClick={() => document.getElementById("imageInput").click()}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <label htmlFor="imageInput" style={{ cursor: "pointer" }}>
                        <img src={uploadIcon} alt="upload" />
                      </label>
                    ),
                    style: {
                      backgroundColor: theme.palette.lightgrey.lightgrey00,
                      color: theme.palette.darkgrey.darkgrey600,
                      outline: "none",
                    },
                  }}
                />
              </Box>
              <Box
                sx={style}
                style={{ display: projectCoverImage ? "flex" : "none" }}
                className={styles.uploadPhoto}
              >
                <TextField
                  fullWidth
                  value="Edit"
                  onClick={handleEdit}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <label style={{ cursor: "pointer" }}>
                        <img src={editIcon} alt="upload" />
                      </label>
                    ),
                    style: {
                      backgroundColor: theme.palette.lightgrey.lightgrey00,
                      color: theme.palette.darkgrey.darkgrey600,
                      outline: "none",
                    },
                  }}
                />
              </Box>
              <Box
                sx={style}
                style={{ display: projectCoverImage ? "flex" : "none" }}
                className={styles.uploadPhoto}
              >
                <TextField
                  fullWidth
                  value="Delete"
                  onClick={handleDelete}
                  InputProps={{
                    readOnly: true,
                    endAdornment: (
                      <label style={{ cursor: "pointer" }}>
                        <img src={deleteIcon} alt="upload" />
                      </label>
                    ),
                    style: {
                      backgroundColor: theme.palette.lightgrey.lightgrey00,
                      color: theme.palette.danger.red500,
                      outline: "none",
                    },
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default DialogBox;
